export default "__VITE_ASSET__KIS9UejU__"